import type { SymbolImportBinding, SymbolTag } from '../../types.js';
import { withCodeNavCacheSqlite } from '../../../sqlite/code-nav-cache/database.js';
import { runCodeNavCacheWriteTransaction } from '../../../sqlite/code-nav-cache/code-nav-cache-sqlite-transaction.js';
import {
  getSymbolIndexParentContext,
  persistSymbolIndexFileData,
  removeSymbolIndexFileData,
  upsertSymbolIndexParentPath,
} from '../sqlite/symbol-index-sqlite.js';

export async function persistSymbolIndexFileAsync(
  resolved: string,
  relPath: string,
  source: string | null,
  tags: SymbolTag[],
  imports: SymbolImportBinding[],
): Promise<void> {
  await withCodeNavCacheSqlite(async (db) => {
    runCodeNavCacheWriteTransaction(db, () => {
      upsertSymbolIndexParentPath(db, resolved);
      const ctx = getSymbolIndexParentContext(db, resolved);
      if (ctx == null) throw new Error(`Failed to resolve symbol index parent: ${resolved}`);
      persistSymbolIndexFileData(db, ctx, relPath, source, tags, imports);
    });
  });
}

/** @deprecated Prefer {@link persistSymbolIndexFileAsync}. */
export function persistSymbolIndexFile(
  resolved: string,
  relPath: string,
  source: string | null,
  tags: SymbolTag[],
  imports: SymbolImportBinding[],
): void {
  void persistSymbolIndexFileAsync(resolved, relPath, source, tags, imports);
}

export async function removeSymbolIndexFileAsync(resolved: string, relPath: string): Promise<void> {
  await withCodeNavCacheSqlite(async (db) => {
    runCodeNavCacheWriteTransaction(db, () => {
      upsertSymbolIndexParentPath(db, resolved);
      const ctx = getSymbolIndexParentContext(db, resolved);
      if (ctx == null) throw new Error(`Failed to resolve symbol index parent: ${resolved}`);
      removeSymbolIndexFileData(db, ctx, relPath);
    });
  });
}

/** @deprecated Prefer {@link removeSymbolIndexFileAsync}. */
export function removeSymbolIndexFile(resolved: string, relPath: string): void {
  void removeSymbolIndexFileAsync(resolved, relPath);
}
